import { render, staticRenderFns } from "./DeleteList.vue?vue&type=template&id=71a92e06&scoped=true&"
import script from "./DeleteList.vue?vue&type=script&lang=js&"
export * from "./DeleteList.vue?vue&type=script&lang=js&"
import style0 from "./DeleteList.vue?vue&type=style&index=0&id=71a92e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a92e06",
  null
  
)

export default component.exports